export default __webpack_public_path__ + "static/media/fusion-003.84ed1d14.svg";